import { Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import * as moment from 'moment';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import Panel from '../../../../../shared/components/card/Panel';
import { FormInputDate, FormInputMobile, FormSelect, FormTextInput } from '../../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE, VALIDATE_MESSAGES } from '../../../../../shared/constants/commonConstants';
import { RootState } from '../../../../../store';
import { doaDodValidation } from '../../../../crm/inPatient/service/crmUtils';
interface ICaseDetailsWrapper {
  form: FormInstance;
  title: string;
  isLoading?: boolean;
}
const CaseDetails = (props: ICaseDetailsWrapper): ReactElement => {

  const { form, title, isLoading } = props;
  const commonDetail = { isLoading, form, claimDetailBackup: {} };
  const {
    payerLookUp = {}, payerList: { payer: { uniqueIdentifier } },
    newAdmission: { isBeneficiarySelected } } = useSelector((state: RootState): RootState => state);

  const isFormDisabled = (key: any): boolean => {
    if (!isBeneficiarySelected) {
      return false;
    }
    return !!form.getFieldsValue([key])[key];
  };

  return <Panel title={title}>
    <Form
      layout="vertical"
      form={form}
      validateMessages={VALIDATE_MESSAGES}
      requiredMark="optional"
      scrollToFirstError={true}>
      <Row gutter={GUTTOR_SPACE}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'fullName',
          size: 8,
          disabled: isFormDisabled('fullName'),
          required: true,
        }} />
        <FormInputMobile detail={{
          ...commonDetail,
          key: 'mobile',
          size: 8,
          required: true,
        }} />
        <FormTextInput detail={{
          ...commonDetail,
          key: 'emailId',
          size: 8,
          disabled: isFormDisabled('emailId'),
          type: 'email',
          required: true,
          maxLength: 50,
        }} />
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <FormTextInput detail={{
          ...commonDetail,
          suffixTestId: 'form',
          key: 'memberId',
          size: 8,
          disabled: isFormDisabled('memberId'),
          required: true,
        }} />
        <FormTextInput detail={{
          ...commonDetail,
          key: 'policyNumber',
          size: 8,
          disabled: isFormDisabled('policyNumber'),
          regex: /[^a-zA-Z\d\-/_]*/gm,
        }} />
        <FormTextInput detail={{
          ...commonDetail,
          key: 'corporateName',
          size: 8,
          disabled: isFormDisabled('corporateName'),
          regex: /[^A-Za-z\b\-//()-*_,:;.&+|]*/gm,
        }} />
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <FormInputDate detail={{
          ...commonDetail,
          key: 'dateOfAdmission',
          size: 8,
          required: true,
          showTime: true,
          allowClear: false,
          rules: [doaDodValidation],
        }} />
        <FormInputDate detail={{
          ...commonDetail,
          key: 'dateOfDischarge',
          size: 8,
          showTime: true,
          allowClear: false,
          required: true,
          disabledDate: (current: any): boolean => (form.getFieldsValue(['dateOfAdmission'])?.dateOfAdmission
            && current < moment.default(form.getFieldsValue(['dateOfAdmission']).dateOfAdmission)),
          rules: [doaDodValidation],
        }}/>
      <FormSelect detail={{
          ...commonDetail,
          key: 'procedure',
          size: 8,
          options: payerLookUp[uniqueIdentifier]?.diagnosis || [],
          mode: 'null',
          selectType: 'category',
          showSearch: true,
          required: true,
      }} />
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'beneficiaryAccountNumber',
          size: 8,
        }} />
        <FormTextInput detail={{
          ...commonDetail,
          key: 'claimedAmount',
          size: 8,
          required: true,
        }} />
      </Row>
    </Form>
  </Panel>;

};

export default CaseDetails;
